<template>
    <div class="learning">
        <van-tabs v-model="active_name" swipeable sticky @change="bindType">
            <van-tab title="学习数据" name="learning_data">
                <div class="learning-data">
                    <div class="learning-hd">
                        <span class="learning-hd-txt">任何质变都来自于量变的积累</span>
                    </div>
                    <div class="learning-total">
                        <span class="learning-total-title">总学习时长</span>
                        <div class="learning-total-time">
                            <span class="total-txt">{{params.sum_study_time_h}}</span>时<span class="total-txt">{{params.sum_study_time_i}}</span>分
                        </div>
                    </div>
                    <div class="learning-title">
                        最近7天的学习时长（分钟）
                    </div>
                    <div class="learning-echarts" id="echarts">

                    </div>
                    <div class="learning-title" style="margin-top: 0">
                        累计
                    </div>
                    <div class="learning-total-tabs">
                        <div class="learning-li">
                            <div class="learning-li-col">
                                <div class="learning-li-icon">
                                    <span class="iconfont icondaka"></span>
                                </div>
                                <div class="learning-li-content">
                                    <span class="learning-li-number">{{params.count_study_day}}天</span>
                                    <span class="learning-li-txt">连续学习</span>
                                </div>
                            </div>
                        </div>
                        <div class="learning-li">
                            <div class="learning-li-col">
                                <div class="learning-li-icon">
                                    <span class="iconfont iconzhangjie"></span>
                                </div>
                                <div class="learning-li-content">
                                    <span class="learning-li-number">{{params.count_study_sections}}章</span>
                                    <span class="learning-li-txt">学的章节</span>
                                </div>
                            </div>
                        </div>
                        <div class="learning-li">
                            <div class="learning-li-col">
                                <div class="learning-li-icon">
                                    <span class="iconfont iconkecheng1"></span>
                                </div>
                                <div class="learning-li-content">
                                    <span class="learning-li-number">{{params.study_count}}个</span>
                                    <span class="learning-li-txt">学的课程</span>
                                </div>
                            </div>
                        </div>
                        <div class="learning-li">
                            <div class="learning-li-col">
                                <div class="learning-li-icon">
                                    <span class="iconfont iconkecheng"></span>
                                </div>
                                <div class="learning-li-content">
                                    <span class="learning-li-number">{{params.complete_study_count}}次</span>
                                    <span class="learning-li-txt">学完课程</span>
                                </div>
                            </div>
                        </div>
                        <div class="learning-li">
                            <div class="learning-li-col">
                                <div class="learning-li-icon">
                                    <span class="iconfont iconxuexizhongxin"></span>
                                </div>
                                <div class="learning-li-content">
                                    <span class="learning-li-number">{{params.question_count}}次</span>
                                    <span class="learning-li-txt">考试次数</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>

            <van-tab title="作业记录" name="task_record">
                <div class="task-record">
                    <van-list
                            v-model="task_loading"
                            :finished="task_finished"
                            finished-text="没有更多了"
                            :immediate-check="false"
                            @load="getUserWorkHisList"
                            class="content-collect"
                    >
                    <div class="task-li" v-for="(item,index) in task_list" :key="index">
                        <div class="task-li-work">
                            <div class="work-name">
                                {{item.work_name}}
                            </div>
                            <div class="work-txt">
                                <div class="work-txt-time">{{item.work_create_date}}</div>
                                <div class="iconfont iconaixin"><span style="margin-left: 5px">{{item.favor_cnt}}</span></div>
                            </div>
                        </div>
                        <div class="work">
                            <div class="task-title">
                                关联内容
                            </div>
                            <div class="time-table-title" @click="bindGoCurriculum(item.course_id)">
                                <div class="table-title-text">
                                    <div class="title-text">
                                        {{item.course_name}}
                                    </div>
                                    <div class="title-text-appointment">
                                        <span>课程</span>
                                        <span class="text-appointment-type">
                                    </span>
                                    </div>
                                </div>
                                <div class="table-title-img">
                                    <img class="title-img" :src="item.course_cover"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    </van-list>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import echarts from 'echarts';
    import {Tab, Tabs,List} from 'vant';
    export default {
        name: "index",
        components:{
            [List.name]:List,
            [Tab.name]:Tab,
            [Tabs.name]:Tabs,
            echarts
        },
        data(){
            return {
                echart:null,
                active_name:'learning_data',
                params:{},//学习数据
                //作业记录
                task_list:[],
                task_total:0,
                task_page:1,
                task_pageSize:10,
                task_loading: false,
                task_finished: false,
            }
        },
        mounted() {
            this.$(document).attr('title','学习中心');
            this.bindType();
        },
        methods:{
            bindType(){
                switch (this.active_name) {
                    case 'learning_data':
                        if(!this.params.count_study_time_fo_week){
                            this.getUserStudyInfo();
                        }
                        break;
                    case 'task_record':
                        if(this.task_list.length == 0){
                            this.getUserWorkHisList(1);
                        }
                        break;
                }
            },
            bindGoCurriculum(course_id){
                this.$router.push(this.util.urlPrefix+'/curriculum/index?course_id='+course_id+'&token='+this.util.token)
            },
            getUserWorkHisList(page){
                var _self=this;
                if(!page){
                    var pageNo = this.task_page;
                    pageNo +=1;

                    this.task_page=pageNo;

                }else{

                    this.task_page=page;

                }

                this.util.server.mini_study_center.user_work_his_list({
                    data:{
                        page:this.task_page,
                        pagesize:this.task_pageSize
                    },
                    methods:'get',
                    callback: (res => {
                        const { code, data, msg } = res;
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.task_total=data.total
                            }

                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.task_list=data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.task_list = this.task_list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.task_loading = false;
                                //判断是否存在下一页
                                if(this.task_total*1 == this.task_list.length){
                                    this.task_finished=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.task_list=[];
                                    this.task_finished=true;
                                    this.task_loading = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            getUserStudyInfo(){
                var _self=this;
                this.util.server.mini_study_center.user_study_info({
                    callback:(res => {

                        if(res.data.sum_study_time_i.toString().length == 1){
                            res.data.sum_study_time_i = '0'+res.data.sum_study_time_i
                        }
                        if(res.data.sum_study_time_h.toString().length == 1){
                            res.data.sum_study_time_h = '0'+res.data.sum_study_time_h
                        }

                        this.params=res.data;

                        this.$nextTick(function () {
                            _self.setLineChart();
                        })
                    })
                })
            },
            setLineChart(){
                var data=[];
                var seriesData=[];

                for (var i=this.params.count_study_time_fo_week.length-1;i>=0;i--){
                    data.push(this.params.count_study_time_fo_week[i].day)
                    seriesData.push(this.params.count_study_time_fo_week[i].study_time)
                }

                let option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        top:'15%',
                        left: '1%',
                        right: '8%',
                        bottom: '7%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisTick: {show:false},
                        axisLine:{
                            lineStyle:{
                                color: '#757575'
                            }
                        },
                        data:data // x轴数据
                    },
                    yAxis: {
                        type: 'value',
                        show:false
                    },
                    series: [
                        {
                            name: '学习时长',
                            type: 'line',
                            data: seriesData,
                            color:'#bbe1fa',//折线颜色
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top',
                                    textStyle: {
                                        color: '#3282b8'
                                    }
                                }
                            },
                        }
                    ]
                };
                this.echart = echarts.init(document.getElementById('echarts'));
                this.echart.setOption(option);
            },
        }
    }
</script>

<!-- 作业记录 -->
<style scoped>
    .time-table-title{
        position: relative;
        margin: 10px;
        height:100px;
    }
    .table-title-text{
        padding-left: 150px;
        height: 100px;
    }
    .title-text{
        font-size: 12px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 32px;
    }
    .title-text-appointment{
        font-size: 12px;
        position: relative;
        margin-top: 50px;
    }
    .text-appointment-type{
        position: absolute;
        right: 0;
        color: #f30;
    }
    .title-text-appointment .iconfont{
        font-size: 12px;
    }
    .table-title-img{
        position: absolute;
        left: 0;
        top: 0;
        font-size: 0;
        height: 100px;
    }
    .title-img{
        width: 145px;
        height: 100%;
    }
    div{
        color: #3a3a3a;
    }
    .task-record{
        width: 100%;
        height: calc(100vh - 44px);
        background-color: #fff;
    }
    .task-li{
        padding: 10px;
        border-bottom: 1px dashed #ccc;
    }
    .task-li-work{
        position: relative;
    }
    .task-li-work .work-name{
        padding-right: 117px;
        font-size: 12px;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        height: 32px;
    }
    .task-li-work .work-txt{
        position: absolute;
        right: 0;
        top: 0;
    }
    .work-txt .work-txt-time{
        font-size: 12px;
    }
    .work-txt .iconfont{
        color: #f30;
        font-size: 12px;
        text-align: right;
    }
    .work{
        margin-top: 10px;
    }
    .task-title{
        font-size: 12px;
        font-weight: bold;
    }
</style>

<!-- 学习数据 -->
<style scoped>
    .learning-li-content{
        width: 50%;
        display: inline-block;
        text-align: center;
        height: 60px;
        color: #3a3a3a;
        vertical-align: middle;
    }
    .learning-li-content .learning-li-number{
        display: block;
        line-height: 30px;
    }
    .learning-li-content .learning-li-txt{
        display: block;
        color: #aaa;
    }
    .learning-li-icon{
        width: 50%;
        display: inline-block;
        text-align: center;
        font-size: 20px;
        height: 60px;
        vertical-align: middle;
    }
    .learning-li-icon .iconfont{
        font-size: 30px;
        color: #0195FF;
        line-height: 60px;
    }
    .learning-li-col{
        box-shadow: 1px 0 10px #eee;
        height: 60px;
    }
    .learning-total-tabs .learning-li{
        height: 100%;
        padding: 15px;
        flex: 0 1 50%;
        box-sizing: border-box;
    }
    .learning-total-tabs{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 15px 0;
    }
    .learning-echarts{
        height: 200px;
        width: 100%;
    }
    .learning-title{
        margin-top: 20px;
        padding: 9px 16px;
        background-color: #F6F6F6;
        color: #A4A4A4;
    }
    .learning-total{
        width: 88%;
        height: 133px;
        background-color: #fff;
        margin: 0 auto;
        box-shadow: 0 3px 5px #eee;
        border-radius: 10px;
        margin-top: -68px;
        padding: 16px 22px;
        box-sizing: border-box;
    }
    .learning-total .learning-total-title{
        color: #A4A4A4;
    }
    .learning-total .learning-total-time{
        color: #3a3a3a;
        text-align: center;
        line-height: 68px;
    }
    .learning-total-time .total-txt{
        font-size: 31px;
    }
    .learning >>> .van-tabs__line{
        background-color: #0195FF;
    }
    .learning-data{
        height: 100%;
        width: 100%;
        background-color: #fff;
    }
    .learning-hd{
        width: 100%;
        height: 132px;
        text-align: center;
        background-image: linear-gradient(45deg , #90cefb, #0195FF);
    }
    .learning-hd .learning-hd-txt{
        margin-top: 22px;
        display: inline-block;
        color: #fff;
        font-size: 16px;
    }
</style>
